<mat-card *ngIf="action.done">
    <mat-list-item>
        <mat-icon matListIcon [ngClass]="action.temperature">{{GLOBAL.ICONS.TEMPERATURE}}</mat-icon>
    </mat-list-item>
    <mat-card-content *ngIf="action.note">
        <p>{{action.note}}</p>
    </mat-card-content>
</mat-card>

<ng-container *ngIf="!action.done">
    <form-builder [item]="item" [values]="item.values" section="main" [edit]="true">
    </form-builder>

    <div class="actionButtons" *ngIf="isRealtor()">
        <button mat-icon-button color="accent"
            [disabled]="!item.modified || item.saving" (click)="saveAction()">
            <mat-icon>check</mat-icon>
        </button>
        <button mat-icon-button class="active" [disabled]="!item.valid || item.saving" (click)="validAction(false)">
            <mat-icon>task_alt</mat-icon>
        </button>
        <button mat-icon-button (click)="dateAction()">
            <mat-icon>event</mat-icon>
        </button>
    </div>

</ng-container>